import { usePortalFeatures } from '@components/RoleBasedView'
import React from 'react'

export interface IPCrossInstrcutorProvider {}

export type IState = {
  allowed: boolean
}

export interface ICrossInstrcutorContext {
  state: IState
}

export const CrossInstrcutorContext = React.createContext<ICrossInstrcutorContext>({} as ICrossInstrcutorContext)

export const CrossInstrcutorProvider: React.FC<IPCrossInstrcutorProvider> = ({ children }) => {
  const { state } = usePortalFeatures({
    configId: 'c::scheduling::instructors::availability::crossInstructor',
  })

  return <CrossInstrcutorContext.Provider value={{ state }}>{children}</CrossInstrcutorContext.Provider>
}

export default CrossInstrcutorProvider
